import React, { useEffect } from 'react';

export default function Toast({ message, type, onDismiss }) {
  useEffect(() => {
    const t = setTimeout(onDismiss, 3000);
    return () => clearTimeout(t);
  }, [onDismiss]);

  return (
    <div className={`toast ${type}`}>
      <span style={{ marginRight: 6 }}>{type === 'success' ? '✓' : '✕'}</span>
      {message}
    </div>
  );
}
